import React from 'react';
import { createUseStyles } from 'react-jss';
import PageHeader from '../Shared/PageHeader'
import WhoAreWeSection from './WhoAreWe';
import WhatWeDoSection from './WhatWeDo';
import MissionSection from './OurMission';
import { Helmet } from 'react-helmet-async';
// import OurTeamSection from './OurTeam';

function AboutPage() {
    const styles = useStyles();
    
    // Your custom structured data for AboutPage
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "name": "About Integrated Holistic Psychotherapy",
        "url": "https://inhop.or.ke/about",
        "mainEntity": {
            "@type": "Organization",
            "name": "Integrated Holistic Psychotherapy",
            "url": "https://inhop.or.ke/",
            "logo": "https://inhop.or.ke/logo.webp",
            "sameAs": [
                "https://www.facebook.com/inhop20/",
                "https://www.instagram.com/inhop20/",
                "https://x.com/inhop20"
            ],
            "founder": {
                "@type": "Person",
                "name": "Dr. Ann Catherine Njeri Rukwaro"
            },
            "description": "Integrated Holistic Psychotherapy provides professional counseling & psychotherapy services in Ruiru, Nairobi. We support individuals, couples, families, and organizations.",
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "Doctors Plaza, Ground Floor, Room F06",
                "addressLocality": "Ruiru",
                "addressRegion": "Nairobi",
                "addressCountry": "KE"
            },
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+254729569381",
                "contactType": "Customer Service",
                "areaServed": "KE",
                "availableLanguage": ["English", "Swahili"]
            }
        }
    };

    return (
        <>
            <Helmet>
                {/* Core SEO */}
                <title>About Us | Integrated Holistic Psychotherapy in Nairobi</title>
                <meta
                    name="description"
                    content="We provide counseling for stress, anxiety, addiction, grief, trauma, relationships, and more. Services for individuals, families, and organizations."
                />
                <meta
                    name="keywords"
                    content="counseling Ruiru, therapy Nairobi, mental health Kenya, psychotherapy Nairobi, addiction counseling, family therapy Kenya"
                />
                <link rel="canonical" href="https://inhop.or.ke/about" />

                {/* Open Graph */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://inhop.or.ke/about" />
                <meta property="og:title" content="About Us | Integrated Holistic Psychotherapy in Ruiru, Nairobi" />
                <meta
                    property="og:description"
                    content="We provide counseling in Ruiru, Nairobi for stress, anxiety, addiction, grief, trauma, relationships, and more. Services for individuals, families, and organizations."
                />
                <meta property="og:image" content="https://inhop.or.ke/logo.webp" />
                <meta property="og:site_name" content="Integrated Holistic Psychotherapy" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@inhop20" />
                <meta name="twitter:creator" content="@inhop20" />
                <meta name="twitter:url" content="https://inhop.or.ke/about" />
                <meta name="twitter:title" content="About Us | Integrated Holistic Psychotherapy in Ruiru, Nairobi" />
                <meta
                    name="twitter:description"
                    content="We provide counseling in Ruiru, Nairobi for stress, anxiety, addiction, grief, trauma, relationships, and more. Services for individuals, families, and organizations."
                />
                <meta name="twitter:image" content="https://inhop.or.ke/logo.webp" />

                {/* Structured Data */}
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            </Helmet>
              
            <div className={styles.pageContainer}>
                <div className={styles.aboutImageHeader}>
                    <PageHeader pageTitle="About Us" />
                </div>
                <div>
                    <WhoAreWeSection />
                </div>
                <div>
                    <MissionSection />
                </div>
                <div>
                    <WhatWeDoSection />
                </div>
                {/* <div className={styles.teamSection}>
                <OurTeamSection />
            </div> */}
            </div>
        </>
    )
}

const useStyles = createUseStyles({
    pageContainer: {
        position: "relative",
        height: "100%",
        width: "100%",
        fontFamily: "Open Sans, sans-serif",
        display: "flex",
        flexDirection: " column"
    },
    teamSection: {
        minHeight: "45vh",
        background: "#122B3E",
    },
})

export default AboutPage